import {useState} from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import StockPurchaserAcquisitionExpenses from "./Stock";
import AssetPurchaserAcquisitionExpenses from "./Asset";

const STOCKPURCHASER = "Stock"
const ASSETPURCHASER = "Asset"

export default function Valuation() {
  // States
  const [selection, setSelection] = useState(STOCKPURCHASER);

  // Methods
  const getSection = () => {
    switch(selection) {

      case STOCKPURCHASER:
        return <StockPurchaserAcquisitionExpenses />

      case ASSETPURCHASER:
        return <AssetPurchaserAcquisitionExpenses />

      default:
        break
    }
  }

  return (
    <>
        <div className="flex items-center justify-between pr-20">
            <h2 className="sectionHead">{selection} Purchaser Acquisition Expenses</h2>
            <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
            <InputLabel id="demo-simple-select-standard-label">Purchaser Type</InputLabel>
            <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selection}
                onChange={(e) => setSelection(e.target.value)}
                label="Purchaser Type"
            >
                <MenuItem value={STOCKPURCHASER}>Stock Purchaser</MenuItem>
                <MenuItem value={ASSETPURCHASER}>Asset Purchaser</MenuItem>
            </Select>
            </FormControl>
        </div>
        <div className="flex justify-center">{getSection()}</div>
    </>
  )
}
